import { type BaseNotificationData, type NotificationDefinition } from "../index";
import { NotificationType } from "../NotificationType";
import { Trans } from "react-i18next";
import { getQuoteDetailsUrl } from "./ExpireQuote";

export interface StatusChangeQuoteData extends BaseNotificationData {
  subTypeCode: NotificationType.StatusChangeQuote;
  salesOrg: string;
  account: string;
  displayAccount: string;
  quoteNumber: string;
  expirationDate: number;
  endCustomerNumber?: string;
}

export const StatusChangeQuoteNotificationDefinition: NotificationDefinition<StatusChangeQuoteData> = {
  type: NotificationType.StatusChangeQuote,
  renderTitle: (data) => {
    return (
      <Trans i18nKey={"notifications.item.title.quoteChange"}>
        Quote <span>{{ quoteNumber: data.quoteNumber }}</span> has changed its status
      </Trans>
    );
  },
  renderTitleGA: (data) => {
    return `Quote ${data.quoteNumber} has changed its status`;
  },
  renderContents: (data, { markAsRead }) => {
    const { displayAccount: accountNumber, endCustomerNumber, quoteNumber } = data;
    const detailsUrl = getQuoteDetailsUrl(data);
    return (
      <>
        {!!endCustomerNumber && (
          <Trans i18nKey={"notifications.item.text.endCustomer.quoteChange"}>
            Account <span>{{ accountNumber }}</span> / End Customer <span>{{ endCustomerNumber }}</span> : Quote{" "}
            <a href={detailsUrl} onClick={() => markAsRead(data)}>
              {{ quoteNumber }}
            </a>{" "}
            has changed its status.
          </Trans>
        )}
        {!endCustomerNumber && (
          <Trans i18nKey={"notifications.item.text.quoteChange"}>
            Account <span>{{ accountNumber }}</span>: Quote{" "}
            <a href={detailsUrl} onClick={() => markAsRead(data)}>
              {{ quoteNumber }}
            </a>{" "}
            has changed its status.
          </Trans>
        )}
      </>
    );
  },
};
